import gsap from 'gsap'

// Official GSAP seamless horizontal loop helper — https://gsap.com/docs/v3/HelperFunctions/helpers/seamlessLoop
function horizontalLoop(items, config) {
	items = gsap.utils.toArray(items)
	config = config || {}
	let tl = gsap.timeline({
			repeat: config.repeat,
			paused: config.paused,
			defaults: { ease: 'none' },
			onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100),
		}),
		length = items.length,
		startX = items[0].offsetLeft,
		times = [],
		widths = [],
		xPercents = [],
		curIndex = 0,
		pixelsPerSecond = (config.speed || 1) * 100,
		snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1),
		totalWidth,
		curX,
		distanceToStart,
		distanceToLoop,
		item,
		i
	gsap.set(items, {
		xPercent: (i, el) => {
			let w = (widths[i] = parseFloat(gsap.getProperty(el, 'width', 'px')))
			xPercents[i] = snap(
				(parseFloat(gsap.getProperty(el, 'x', 'px')) / w) * 100 +
					gsap.getProperty(el, 'xPercent')
			)
			return xPercents[i]
		},
	})
	gsap.set(items, { x: 0 })
	totalWidth =
		items[length - 1].offsetLeft +
		(xPercents[length - 1] / 100) * widths[length - 1] -
		startX +
		items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], 'scaleX') +
		(parseFloat(config.paddingRight) || 0)
	for (i = 0; i < length; i++) {
		item = items[i]
		curX = (xPercents[i] / 100) * widths[i]
		distanceToStart = item.offsetLeft + curX - startX
		distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, 'scaleX')
		tl.to(
			item,
			{
				xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
				duration: distanceToLoop / pixelsPerSecond,
			},
			0
		)
			.fromTo(
				item,
				{
					xPercent: snap(((curX - distanceToLoop + totalWidth) / widths[i]) * 100),
				},
				{
					xPercent: xPercents[i],
					duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
					immediateRender: false,
				},
				distanceToLoop / pixelsPerSecond
			)
			.add('label' + i, distanceToStart / pixelsPerSecond)
		times[i] = distanceToStart / pixelsPerSecond
	}
	function toIndex(index, vars) {
		vars = vars || {}
		Math.abs(index - curIndex) > length / 2 &&
			(index += index > curIndex ? -length : length)
		let newIndex = gsap.utils.wrap(0, length, index),
			time = times[newIndex]
		if (time > tl.time() !== index > curIndex) {
			vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) }
			time += tl.duration() * (index > curIndex ? 1 : -1)
		}
		curIndex = newIndex
		vars.overwrite = true
		return tl.tweenTo(time, vars)
	}
	tl.next = vars => toIndex(curIndex + 1, vars)
	tl.previous = vars => toIndex(curIndex - 1, vars)
	tl.current = () => curIndex
	tl.toIndex = (index, vars) => toIndex(index, vars)
	tl.times = times
	tl.progress(1, true).progress(0, true)
	if (config.reversed) {
		tl.vars.onReverseComplete()
		tl.reverse()
	}
	return tl
}

const MAX_CLONES = 40

export const marquee = () => {
	const els = document.querySelectorAll('.site-marquee')
	if (!els.length) return false

	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
	if (reduced) return

	els.forEach(el => {
		const track = el.querySelector('.site-marquee__track')
		if (!track) return

		const baseItem = track.querySelector('.site-marquee__item')
		const baseArrow = track.querySelector('.site-marquee__arrow')
		if (!baseItem || !baseArrow) return

		let timeline
		let resizeTimer

		const start = () => {
			if (timeline) {
				timeline.kill()
				timeline = null
			}

			track.querySelectorAll('[data-marquee-clone]').forEach(n => n.remove())
			gsap.set(track.children, { clearProps: 'all' })

			const basePairWidth =
				baseItem.getBoundingClientRect().width + baseArrow.getBoundingClientRect().width
			if (!basePairWidth) return

			const target = el.clientWidth + basePairWidth
			let safety = 0
			while (track.scrollWidth < target && safety < MAX_CLONES) {
				const itemClone = baseItem.cloneNode(true)
				const arrowClone = baseArrow.cloneNode(true)
				itemClone.setAttribute('aria-hidden', 'true')
				arrowClone.setAttribute('aria-hidden', 'true')
				itemClone.dataset.marqueeClone = '1'
				arrowClone.dataset.marqueeClone = '1'
				track.appendChild(itemClone)
				track.appendChild(arrowClone)
				safety++
			}

			timeline = horizontalLoop(track.children, {
				speed: 0.4,
				paddingRight: 0,
				repeat: -1,
			})
		}

		start()

		el.addEventListener('mouseenter', () => timeline && timeline.pause())
		el.addEventListener('mouseleave', () => timeline && timeline.play())

		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer)
			resizeTimer = setTimeout(start, 150)
		})
	})
}

export default marquee
